import LeadArticle from './children/LeadArticle'

const HomeTopContent = () => {
  return <LeadArticle />
}

export default HomeTopContent
